// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"309602b4","546":"309602b4"}[chunkId] + ".chunk.css";
};